import { Component, OnDestroy, OnInit } from '@angular/core';
import { AtlasService } from '../atlas.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'altas-payment-digital-platform',
  templateUrl: './altas-payment-digital-platform.component.html',
  styleUrls: ['./altas-payment-digital-platform.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class AtlasPaymentDigitalPlatformComponent implements OnInit, OnDestroy {
  subscriptions = new Array<any>();
  digitalPlatformData:any;
  apiContent:any;
  internationalPayoutApiContent:any;
  constructor(private atlasPageService: AtlasService) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  ngOnInit(): void {
    this.atlasPageService.digitalPlatform$.subscribe(data => {
      this.digitalPlatformData = data?.fields;
      this.apiContent = this.digitalPlatformData?.component1?.filter(
        (el:any) => el?.fields?.title != "Outsource your cross-border payments"
      );
      this.internationalPayoutApiContent =
        this.digitalPlatformData?.component1?.filter(
          (el:any) => el?.fields?.title === "Outsource your cross-border payments"
        );
    });
  }
  navigateToVertoFX(link:any) {
    location.pathname = link;
  }
}
